import { Link, useMatch } from "react-router-dom";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";
import { pages } from "@/routes/pages";
import { formatCredits } from "./format";
import { Meter } from "./meter";
import { useCredits } from "./use-billing";

/** Sidebar credit meter. Renders from the synced balance (no network); plan context fills in later. */
export function CreditMeter() {
	const credits = useCredits();
	const active = !!useMatch("/settings/billing");
	if (credits.total == null) return null;
	const warn = credits.level !== "ok";
	const max = Math.max(credits.allowance ?? 0, credits.included + credits.pack, 1);
	return (
		<Tooltip>
			<TooltipTrigger asChild>
				<Link
					to="/settings/billing"
					onPointerEnter={() => void pages.billing.preload()}
					className={cn(
						"flex flex-col gap-1.5 rounded-md border bg-card px-2.5 py-2 outline-none transition-colors duration-75 hover:bg-sidebar-accent focus-visible:ring-2 focus-visible:ring-ring/30",
						active && "bg-sidebar-accent",
						warn && "border-foreground/40",
					)}
				>
					<span className="flex items-center justify-between">
						<span className="mono-label flex items-center gap-1.5">
							{warn && <span className="size-1.5 animate-dot-pulse rounded-full bg-destructive" />}
							Credits
						</span>
						<span className="font-mono text-[12px] tabular-nums text-foreground">
							{formatCredits(credits.spendable ?? 0)}
						</span>
					</span>
					<Meter value={credits.included} extra={credits.pack} max={max} warn={warn} />
				</Link>
			</TooltipTrigger>
			<TooltipContent side="right">
				{formatCredits(credits.included)} plan · {formatCredits(credits.pack)} pack credits
				{credits.level === "past_due" && " · plan credits paused (payment failed)"}
			</TooltipContent>
		</Tooltip>
	);
}
